<template>
  <div data-test-id="establishment-modal-reviews-link"
       class="review"
       :class="{
      ['review--size-' + size]: size,
      'review--underlined': underlined,
    }"
       @click.stop="$emit('showReviews')"
  >
    <div class="review__stars">
      <div v-for="(item, index) in 5"
           :key="index"
           class="review__star-wrapper"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div class="review__star"
             v-html="StarCurrentColor"
        />
        <div class="review__star"
             :class="{
            'review__star--active': fullStar(index) && !white,
            'review__star--active-white': fullStar(index) && white,
            'review__star--half': halfAStar(index),
          }"
             v-html="StarCurrentColor"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
    <div v-if="amount"
         class="review__amount"
         :class="{ small: small }"
    >
      <span v-if="!small"
            class="review__amount__average"
            :class="{ blue: blue }"
      >
        {{ rating.toFixed(1) }}
      </span>
      <span class="review__amount__count">
        ({{ amount > 500 ? '500+' : amount }}
        <template v-if="!small"> reviews</template>)
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import StarCurrentColor from '@/assets/img/icons/star_current_color.svg?raw'

defineEmits([ 'show-reviews' ])

const props = defineProps({
  rating: {
    type: Number,
    required: true,
  },
  amount: {
    type: Number,
    default: 0,
  },
  size: {
    type: String,
    default: 'md',
  },
  white: {
    type: Boolean,
    default: false,
  },
  underlined: {
    type: Boolean,
    default: false,
  },
  blue: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
})

function halfAStar(index) {
  return props.rating - index >= 0.25 && props.rating - index < 0.75
}

function fullStar(index) {
  return props.rating >= index && props.rating - index >= 0.25
}
</script>

<style lang="scss">
.review {
  $self:      &;
  display:    flex;
  align-items: center;
  max-height: 16px;

  &__stars {
    white-space: nowrap;
    align-items: center;
    display: flex;

    #{ $self }__star {
      color: var(--color-neutral-tertiary);

      svg {
        width:    1rem;
        height:   1rem;
        position: absolute;
        left:     50%;
        transform: translateX(-50%);
      }

      &--active {
        color: var(--color-brand-lighter);
      }

      &--active-white {
        color: white;
      }
    }
  }

  &__star-wrapper,
  &__star {
    width: 1rem;
    height: 1rem;
  }

  &__star-wrapper {
    margin: 0 0.05rem;
    position: relative;
  }

  &__star {
    position: absolute;

    &--half {
      overflow: hidden;
      clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
    }
  }

  &__amount {
    font-size: 0.875rem;
    margin-left: 0.5rem;
    color:     var(--color-neutral-secondary);

    &.small {
      margin-top: 2px;
      margin-left: 2px;
    }

    &__average.blue {
      color: var(--color-neutral-primary);
    }
  }

  &--underlined {
    #{$self} {
      &__amount {
        &__average,
        &__count {
          text-decoration: underline;
        }
      }
    }
  }

  &--size- {
    &sm {
      #{ $self }__stars {
        #{ $self }__star {
          svg {
            width: 0.75rem;
            height: 0.75rem;
          }
        }
      }
    }
  }
}
</style>
